import * as types from './types'
import UserResource from '@/services/api/user'

export const actions = {
	fetchNotifications ({ commit }, user) {
		return new Promise((resolve, reject) => {
			UserResource.getNotifications(user.id).then((notifications) => {
				commit(types.FETCH_NOTIFICATIONS, { notifications })
				resolve()
			}).catch(() => {
				reject()
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/store/modules/Notifications/actions.js